import { render, staticRenderFns } from "./notFind.vue?vue&type=template&id=2abe8696&scoped=true"
import script from "./notFind.vue?vue&type=script&lang=js"
export * from "./notFind.vue?vue&type=script&lang=js"
import style0 from "./notFind.vue?vue&type=style&index=0&id=2abe8696&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe8696",
  null
  
)

export default component.exports